import { LOCALE, WORDING } from '../configuration';

export function useTranslate() {
    return {
        locale: LOCALE,
        t: (key: string) => WORDING[LOCALE][key] || key
    };
}
